import events from 'widget/api/events';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const actions = {
  create: async (_, { name }) => {
    try {
      await events.create(name);
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions,
  mutations: {},
};
